{
  "es": {
    "baseBtn": {
      "labels": {
        "loading": "Please wait..."
      }
    }
  }
}
